// Content for the "Despre noi" page (lvgimob.md, RO + RU).
// Company data comes from legal.js (OPERATOR) — single source of truth.

import { OPERATOR } from './legal';

export const ABOUT_META = {
  roTitle: 'Despre noi | LVG Imob — agenție imobiliară din Ungheni',
  ruTitle: 'О нас | LVG Imob — агентство недвижимости в Унгенах',
  roDesc: 'LVG Imob — agenție imobiliară locală din Ungheni, activă din 2017. Peste 500 de tranzacții de vânzare și închiriere, consultanță completă pentru cumpărare, vânzare și chirie.',
  ruDesc: 'LVG Imob — местное агентство недвижимости в Унгенах, работает с 2017 года. Более 500 сделок по продаже и аренде, полное сопровождение при покупке, продаже и аренде.',
  roH1: 'Despre noi',
  ruH1: 'О нас',
  roPath: '/despre-noi',
  ruPath: '/ru/o-nas',
};

// Real Google reviews of the agency, original Romanian text (client content).
export const REVIEWS = [
  {
    name: 'Maria Barbarii',
    text: 'Recomand cu drag! A postat anunțul aseară, iar în mai puțin de 24 de ore apartamentul era deja vândut. Profesionalism și rezultate care vorbesc de la sine!',
  },
  {
    name: 'Tatiana Bodrug',
    text: 'Recomand cu mare drag această agenție imobiliară! Am avut parte de o colaborare minunată pentru cumpărarea primei noastre locuințe. Agentul a dat dovadă de multă răbdare, ne-a răspuns la toate întrebările, a fost alături de noi de la început până la sfârșit. Servicii la cel mai înalt nivel.',
  },
  {
    name: 'Cosnean Anastasia',
    text: 'Foarte plăcut când te poți baza pe cineva de încredere. Am vândut apartamentul de la distanță. Recomand cu toată încrederea.',
  },
  {
    name: 'Mihalachi Adriana',
    text: 'Vă mulțumim pentru profesionalismul și sprijinul oferit în vânzarea apartamentului nostru. Ați făcut ca întregul proces să fie simplu și fără stres.',
  },
  {
    name: 'Dumitru Nistiriuc',
    text: 'Agenția Imobiliară Lvgimob este cea mai bună din Raionul Ungheni, iar Anatolie este un profesionist adevărat, care lucrează foarte eficient, găsind operativ soluții la orice întrebare! Recomand cu încredere să apelați la serviciile Agenției Lvgimob.',
  },
  {
    name: 'Gena Kissa',
    text: 'Am avut o experiență excelentă colaborând cu d. Anatol în procesul de vânzare a locuinței. De la prima întâlnire, el s-a remarcat prin profesionalism și promptitudine, care m-a făcut să mă simt în siguranță și bine informată la fiecare pas.',
  },
];

export const ABOUT = {
  ro: {
    eyebrow: 'Agenție imobiliară locală în Ungheni',
    heroTitle: 'Suntem alături de tine, de la prima vizionare până la semnătura finală.',
    heroText: 'LVG Imob este agenția imobiliară de încredere din Ungheni. De peste 9 ani ajutăm oamenii să vândă, să cumpere și să închirieze apartamente, case, terenuri și spații comerciale — cu răbdare, transparență și rezultate reale.',
    heroFacts: [
      { label: 'Compania', value: OPERATOR.name },
      { label: 'IDNO', value: OPERATOR.idno },
      { label: 'Activă din', value: '18 octombrie 2017' },
      { label: 'Sediul', value: OPERATOR.office },
      { label: 'Telefon', value: OPERATOR.phone, href: `tel:${OPERATOR.phone.replace(/\s/g, '')}` },
      { label: 'E-mail', value: OPERATOR.email, href: `mailto:${OPERATOR.email}` },
    ],
    statsEyebrow: 'Cifre care vorbesc',
    statsTitle: 'Rezultate construite cu grijă, zi de zi',
    stats: [
      { value: '500+', label: 'tranzacții de succes la vânzare și chirie' },
      { value: '2017', label: 'anul în care am început activitatea' },
      { value: 'Ungheni', label: 'agenție locală, prezentă în raionul Ungheni' },
      { value: 'Sute', label: 'de clienți mulțumiți care ne recomandă' },
    ],
    servicesEyebrow: 'Ce facem',
    servicesTitle: 'Serviciile noastre',
    services: [
      {
        icon: 'sale',
        title: 'Vânzare',
        text: 'Evaluare corectă, promovare eficientă și sprijin complet până la semnarea actelor.',
        href: '/apartamente',
      },
      {
        icon: 'buy',
        title: 'Cumpărare',
        text: 'Consultanță personalizată și vizionări rapide, ca să alegi locuința potrivită fără stres.',
        href: '/apartamente',
      },
      {
        icon: 'rent',
        title: 'Chirie',
        text: 'Găsim chiriașul potrivit sau locuința ideală, cu contracte clare și proces simplu.',
        href: '/apartamente/chirie',
      },
      {
        icon: 'mortgage',
        title: 'Ipotecă',
        text: 'Consultanță pentru credit ipotecar prin partenerul nostru. LVG Imob nu acordă credite.',
        href: 'https://ipoteca.lvgimob.md/',
        external: true,
      },
    ],
    valuesEyebrow: 'De ce LVG Imob',
    valuesTitle: 'Valorile care ne ghidează',
    values: [
      { title: 'Încredere și transparență', text: 'Spunem lucrurilor pe nume și te ținem informat la fiecare pas, fără promisiuni goale.' },
      { title: 'Experiență locală', text: 'Cunoaștem piața imobiliară din Ungheni și împrejurimi — străzile, prețurile, oamenii.' },
      { title: 'Sprijin complet', text: 'De la evaluare și fotografii până la acte și predarea cheilor, suntem alături de tine.' },
      { title: 'Rezultate reale', text: 'Peste 500 de tranzacții de succes ne confirmă încrederea pe care o primim de la clienți.' },
    ],
    reviewsEyebrow: 'Recenzii',
    reviewsTitle: 'Ce spun clienții noștri',
    reviewsNote: 'Recenzii lăsate de clienții noștri în profilul companiei pe Google.',
    reviewsGoogle: 'Recenzii Google',
    contactTitle: 'Hai să vorbim despre proprietatea ta',
    contactText: 'Sună-ne, scrie-ne sau treci pe la birou — îți răspundem cu drag și îți oferim o evaluare corectă, fără obligații.',
    contactBtn: 'Contactează-ne',
    sellBtn: 'Vreau să vând',
  },
  ru: {
    eyebrow: 'Местное агентство недвижимости в Унгенах',
    heroTitle: 'Мы рядом — от первого просмотра до финальной подписи.',
    heroText: 'LVG Imob — агентство недвижимости в Унгенах, которому доверяют. Более 9 лет мы помогаем людям продавать, покупать и арендовать квартиры, дома, участки и коммерческую недвижимость — терпеливо, прозрачно и с реальными результатами.',
    heroFacts: [
      { label: 'Компания', value: OPERATOR.name },
      { label: 'IDNO', value: OPERATOR.idno },
      { label: 'Работаем с', value: '18 октября 2017 года' },
      { label: 'Офис', value: 'ул. Ион Крянгэ 4, СЭЗ Унгень, г. Унгены, MD-3603' },
      { label: 'Телефон', value: OPERATOR.phone, href: `tel:${OPERATOR.phone.replace(/\s/g, '')}` },
      { label: 'E-mail', value: OPERATOR.email, href: `mailto:${OPERATOR.email}` },
    ],
    statsEyebrow: 'Цифры говорят сами',
    statsTitle: 'Результаты, которые мы строим каждый день',
    stats: [
      { value: '500+', label: 'успешных сделок по продаже и аренде' },
      { value: '2017', label: 'год начала нашей работы' },
      { value: 'Унгены', label: 'местное агентство в Унгенском районе' },
      { value: 'Сотни', label: 'довольных клиентов, которые нас рекомендуют' },
    ],
    servicesEyebrow: 'Что мы делаем',
    servicesTitle: 'Наши услуги',
    services: [
      {
        icon: 'sale',
        title: 'Продажа',
        text: 'Справедливая оценка, эффективное продвижение и полная поддержка до подписания документов.',
        href: '/ru/kvartiry/prodazha',
      },
      {
        icon: 'buy',
        title: 'Покупка',
        text: 'Персональные консультации и быстрые просмотры, чтобы выбрать подходящее жильё без стресса.',
        href: '/ru/kvartiry/prodazha',
      },
      {
        icon: 'rent',
        title: 'Аренда',
        text: 'Найдём подходящего арендатора или идеальное жильё — с понятными договорами и простым процессом.',
        href: '/ru/kvartiry/arenda',
      },
      {
        icon: 'mortgage',
        title: 'Ипотека',
        text: 'Консультация по ипотечному кредиту через нашего партнёра. LVG Imob не выдаёт кредиты.',
        href: 'https://ipoteca.lvgimob.md/ru/',
        external: true,
      },
    ],
    valuesEyebrow: 'Почему LVG Imob',
    valuesTitle: 'Ценности, которые нами движут',
    values: [
      { title: 'Доверие и прозрачность', text: 'Говорим честно и держим вас в курсе на каждом этапе — без пустых обещаний.' },
      { title: 'Местный опыт', text: 'Мы знаем рынок недвижимости Унген и окрестностей — улицы, цены, людей.' },
      { title: 'Полное сопровождение', text: 'От оценки и фотографий до документов и передачи ключей — мы рядом с вами.' },
      { title: 'Реальные результаты', text: 'Более 500 успешных сделок подтверждают доверие наших клиентов.' },
    ],
    reviewsEyebrow: 'Отзывы',
    reviewsTitle: 'Отзывы наших клиентов',
    reviewsNote: 'Отзывы оставлены нашими клиентами в профиле компании в Google. Текст приведён в оригинале, на румынском языке.',
    reviewsGoogle: 'Отзывы из Google',
    contactTitle: 'Поговорим о вашей недвижимости',
    contactText: 'Позвоните, напишите или загляните в офис — мы с радостью ответим и предложим справедливую оценку без обязательств.',
    contactBtn: 'Свяжитесь с нами',
    sellBtn: 'Хочу продать',
  },
};
